import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, OnInit, inject, input } from '@angular/core';
import { FormGroup, NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent, MatCardSubtitle, MatCardTitle } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatError, MatFormField, MatHint, MatInput, MatLabel } from '@angular/material/input';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { NotificationService } from '@app/core/notifications/notification.service';
import { ObjetMaquette } from '@app/features/editeur/models/objet-maquette.model';
import { CommandFactoryService } from '@app/features/editeur/services/command-factory.service';
import { IfIsNotAuthorized } from '@app/shared/autorisations/autorisations.decorator.ts';
import { Traitement } from '@app/shared/autorisations/traitements';
import { Espace, TypeObjetMaquette } from '@pcscol/odf-api-v1-angular';
import { first } from 'rxjs/operators';
import { FormMatErrorsDirective } from '../../../../../../shared/base-form/form-mat-errors/form-mat-errors.directive';
import { AbstractDescripteursComponent } from '../../../../../../shared/form-models/abstract-descripteurs.component';
import { DescripteursSyllabusForm } from './descripteurs-syllabus-form';

@Component({
    selector: 'app-formulaire-descripteurs-syllabus',
    templateUrl: './descripteurs-syllabus.component.html',
    styleUrls: ['./descripteurs-syllabus.component.scss'],
    imports: [
        MatCardTitle,
        MatCardContent,
        ReactiveFormsModule,
        MatCard,
        MatCardSubtitle,
        MatFormField,
        MatLabel,
        CdkTextareaAutosize,
        MatInput,
        MatHint,
        FormMatErrorsDirective,
        MatError,
        MatSlideToggle,
        MatButton,
        MatIcon
    ]
})
export class DescripteursSyllabusComponent extends AbstractDescripteursComponent implements OnInit {
    private fb = inject(NonNullableFormBuilder);
    private commandFactoryService = inject(CommandFactoryService);
    private notificationService = inject(NotificationService);
    readonly espace = input.required<Espace>();
    readonly objetMaquette = input<ObjetMaquette>();
    readonly typeObjetMaquette = input<TypeObjetMaquette>();

    form: DescripteursSyllabusForm;

    @IfIsNotAuthorized(Traitement.ODF_MODIFIER_DESCRIPTEURS_SYLLABUS_OBJET_MAQUETTE)
    disableFormIfNotAutorised() {
        this.form.disable();
    }

    getDescripteursObjetFormationSyllabus() {
        return this.form.asFormGroup.controls.descripteursObjetFormationSyllabus as FormGroup;
    }

    ngOnInit() {
        this.form = DescripteursSyllabusForm.createForm(this.fb, this.typeObjetMaquette()!, this.objetMaquette()!.descripteursSyllabus);
        this.disableFormIfNotAutorised();
    }

    toggleOuvertureALaMobiliteEntrante() {
        this.form.asFormGroup.controls.ouvertureALaMobiliteEntrante.patchValue(
            !this.form.asFormGroup.controls.ouvertureALaMobiliteEntrante.value
        );
        this.form.asFormGroup.controls.ouvertureALaMobiliteEntrante.markAsDirty();
    }

    modifierDescripteursSyllabus() {
        this.commandFactoryService
            .modifierDescripteursSyllabusObjetMaquetteCommand(
                this.objetMaquette()!.id!,
                this.objetMaquette()!.version,
                this.objetMaquette()!.descripteursSyllabus!,
                this.form.asDescripteursSyllabus
            )
            .do()
            .pipe(first())
            .subscribe(() => {
                // this.objetMaquette()! = om; // TODO check si désynchro
                this.form.asFormGroup.markAsPristine();
                this.notificationService.warn(`Les descripteurs du syllabus de l'objet ont été enregistrés avec succès.
                Si les données du syllabus ont déjà été exportées pour publication, pensez à réactualiser ces données après modifications.`);
            });
    }
}
